import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueSweetalert2 from 'vue-sweetalert2'
import VueGoodTablePlugin from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css'
import vSelect from 'vue-select'
import './session'
import 'vue-select/dist/vue-select.css';
import InputColorPicker from "vue-native-color-picker";
import ToggleButton from 'vue-js-toggle-button'
import store from './store'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import Snotify, { SnotifyPosition } from 'vue-snotify';
import globalVar from "./Config/config";
import loaders from './pages/advanced-ui/loaders';
import CircleLoader from '@/pages/loaders/CircleLoader.vue' // Adjust the path accordingly
Vue.use(ToggleButton)
Vue.use(InputColorPicker);
Vue.use(BootstrapVue)
Vue.use(VueSweetalert2)
Vue.use(router)
Vue.use(store)
Vue.component('v-select', vSelect)
Vue.use(VueGoodTablePlugin);
Vue.config.productionTip = false

Vue.component('CircleLoader', CircleLoader);
const options = {
  toast: {
    position: SnotifyPosition.rightTop,
  },
  global:{
    maxOnScreen: 1,
    preventDuplicates:true,
    oneAtTime:true
}
};
Vue.use(Snotify, options);

Vue.prototype.$showNotification = function(data, type = 'error') {
  this.$snotify[type](data.message, {
    timeout: 2000,
    showProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
  });
};

Vue.component('loaders', loaders);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


